/**
 * Copyright Mántum All Rights Reserved.
 */
import en from './en.json';
import es from './es.json';

import type { Locale } from '@mantum/kanela';

export default function getMessage(key: string, locale: Locale) {
    const dict = locale === 'es' ? es : en;
    return key in dict ? dict[key as keyof unknown] : key;
}
